import { __decorate, __extends } from "tslib";
import Vue from "vue";
import { Component, Prop } from 'vue-property-decorator';
import CouponCountdown from './coupon-countdown.vue';
var CouponExit = /** @class */ (function (_super) {
    __extends(CouponExit, _super);
    function CouponExit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.exitModuleContainerDisplay = true;
        _this.couponDimmerDisplay = true;
        _this.buttonCopyDisplay = true;
        _this.buttonCopySuccess = false;
        _this.showExitIntent = false;
        return _this;
    }
    //copyValue: string = this.couponCode;
    CouponExit.prototype.closeCouponLayer = function () {
        this.exitModuleContainerDisplay = false;
        this.couponDimmerDisplay = false;
    };
    CouponExit.prototype.copyToClipboard = function () {
        if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
            var hiddenInput = this.$refs.hiddenInput;
            var editable = hiddenInput.contentEditable;
            var readOnly = hiddenInput.readOnly;
            hiddenInput.contentEditable = true;
            hiddenInput.readOnly = true;
            var range = document.createRange();
            range.selectNodeContents(hiddenInput);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
            hiddenInput.setSelectionRange(0, 999999);
            hiddenInput.contentEditable = editable;
            hiddenInput.readOnly = readOnly;
            document.execCommand('copy');
        }
        else {
            //@ts-ignore
            navigator.clipboard.writeText(this.couponCode);
        }
        //@ts-ignore
        window.dataLayer = window.dataLayer || [];
        //@ts-ignore
        window.dataLayer.push({
            'event': 'CouponGenerator',
            'eventCategory': 'CouponGenerator',
            'eventAction': 'copy',
            'eventLabel': this.couponCode
        });
    };
    CouponExit.prototype.copyClick = function () {
        //@ts-ignore
        this.copyToClipboard();
        this.buttonCopyDisplay = false;
        this.buttonCopySuccess = true;
        setTimeout(this.closeCouponLayer, 1000);
    };
    __decorate([
        Prop({ default: false })
    ], CouponExit.prototype, "showExitIntent", void 0);
    __decorate([
        Prop()
    ], CouponExit.prototype, "claim", void 0);
    __decorate([
        Prop()
    ], CouponExit.prototype, "codeLabel", void 0);
    __decorate([
        Prop()
    ], CouponExit.prototype, "countDown", void 0);
    __decorate([
        Prop()
    ], CouponExit.prototype, "couponCode", void 0);
    __decorate([
        Prop()
    ], CouponExit.prototype, "deadline", void 0);
    __decorate([
        Prop()
    ], CouponExit.prototype, "language", void 0);
    __decorate([
        Prop()
    ], CouponExit.prototype, "linkLabel", void 0);
    __decorate([
        Prop()
    ], CouponExit.prototype, "linkUrl", void 0);
    __decorate([
        Prop()
    ], CouponExit.prototype, "longTitle", void 0);
    __decorate([
        Prop()
    ], CouponExit.prototype, "subClaim", void 0);
    __decorate([
        Prop()
    ], CouponExit.prototype, "terms", void 0);
    __decorate([
        Prop()
    ], CouponExit.prototype, "labelCopyCode", void 0);
    __decorate([
        Prop()
    ], CouponExit.prototype, "labelCopyCodeSuccess", void 0);
    __decorate([
        Prop()
    ], CouponExit.prototype, "labelCountdownHeadline", void 0);
    CouponExit = __decorate([
        Component({
            components: { CouponCountdown: CouponCountdown }
        })
    ], CouponExit);
    return CouponExit;
}(Vue));
export default CouponExit;
